module.exports = __webpack_public_path__ + "static/media/b-sci-major-39_LR.360432ca.jpg";